import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  helmet: {
    id: 'app.auth.consent.Page.helmet',
  },
  title: {
    id: 'app.auth.consent.Page.title',
  },
  description: {
    id: 'app.auth.consent.Page.description',
  },
  error: {
    id: 'app.auth.consent.Page.error',
  },
  continue: TRANSLATED_ACTIONS.continue,
});
